import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

/**
 * Expense Approval Dialog Component
 */
const ApprovalDialog = ({
  open,
  onOpenChange,
  expense,
  action, // 'approve' or 'reject'
  formatCurrency,
  onApprove
}) => {
  const { t } = useTranslation();
  const [comments, setComments] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleOpenChange = (isOpen) => {
    if (!isOpen) {
      setComments('');
    }
    onOpenChange(isOpen);
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    await onApprove(expense?.id, action, comments);
    setIsSubmitting(false);
    handleOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {action === 'approve' ? t('budget.approveExpense') : t('budget.rejectExpense')}
          </DialogTitle>
          <DialogDescription>
            {expense && (
              <span>
                {expense.subcategory} - {formatCurrency(expense.amount_pln)}
              </span>
            )}
          </DialogDescription>
        </DialogHeader>
        
        <div className="py-4">
          <Label>{t('budget.comments')}</Label>
          <Textarea
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            placeholder={action === 'reject' ? t('budget.reasonForRejectionRequired') : t('budget.optionalComments')}
            rows={3}
          />
        </div>
        
        <DialogFooter>
          <Button 
            variant="outline" 
            onClick={() => handleOpenChange(false)}
            disabled={isSubmitting}
           data-testid="dialog-cancel-btn">
            {t('budget.cancel')}
          </Button>
          <Button 
            variant={action === 'approve' ? 'default' : 'destructive'}
            onClick={handleSubmit}
            disabled={isSubmitting}
           data-testid="dialog-submit-btn">
            {isSubmitting ? 'Processing...' : (action === 'approve' ? t('budget.approve') : t('budget.reject'))}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ApprovalDialog;
